module.exports = __webpack_public_path__ + "img/logo_cropped.7a7853cd.png";